var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
const CellElement = styled.div `
  ${({ left }) => left && `grid-column-start: ${left}`};
  ${({ top }) => top && `grid-row-start: ${top}`};
  ${({ height }) => height && `grid-row-end: ${height}`};
  ${({ width }) => width && `grid-column-end: ${width}`};
  ${({ area }) => area && `grid-area: ${area}`};
  align-self: ${props => props.align};
  justify-self: ${props => props.justify};
  z-index: ${props => props.zIndex};
  ${props => props.mediaQuery}
`;
const Cell = (_a) => {
    var { children, width, height, top, left, align, justify, area, zIndex, mediaQuery } = _a, props = __rest(_a, ["children", "width", "height", "top", "left", "align", "justify", "area", "zIndex", "mediaQuery"]);
    return (_jsx(CellElement, Object.assign({ width: width, height: height, top: top, left: left, align: align, justify: justify, area: area, zIndex: zIndex, mediaQuery: mediaQuery }, props, { children: children })));
};
export default Cell;
